import React from 'react'
import styles from './ClimbPicker.scss'
import { MapPicker } from 'common/MapPicker'
import { Map } from 'common/Map'
import { Button } from 'common/Button'
import { Msg, commonVerbs, commonCTAs } from 'lib/localization'
import { FormattedMessage as T, defineMessages } from 'react-intl'

const messages = defineMessages({
  climbAnimation: {
    id: 'ClimbPicker.climbAnimation',
    defaultMessage: 'Climb Animation'
  },
  selectedRide: {
    id: 'ClimbPicker.selectedRide',
    defaultMessage: 'selected ride'
  }
})

export class ClimbPicker extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      rideId: props.rides.size === 1 ? props.rides.first().get('id') : null,
      highlightSlice: null,
      showHint: false
    }
  }

  selectRide = ({ rideId }) => this.setState({ rideId })

  onSegmentSelected = (highlightSlice) => {
    this.setState({ highlightSlice, showHint: false })
  }

  onSegmentUnselected = () => this.setState({ highlightSlice: null })

  confirmClimb = () => {
    const { onClimbSelected } = this.props
    const { rideId, highlightSlice } = this.state
    const readyToConfirm = rideId && highlightSlice
    if (readyToConfirm) {
      onClimbSelected({ rideId, highlightSlice })
    } else {
      this.setState({ showHint: true })
    }
  }

  render () {
    const { rides, cancelable, onCancel, metricUnits } = this.props
    const { rideId, highlightSlice, showHint } = this.state
    const readyToConfirm = rideId && highlightSlice
    if (!rideId) {
      return (
        <div className={styles.ClimbPicker}>
          <h2><Msg m={messages.climbAnimation} /></h2>
          <MapPicker cancelable={cancelable} onCancel={onCancel} onChange={this.selectRide} prompt='Select your ride' rides={rides} />
        </div>
      )
    }
    const ride = rides.get(rideId)
    return (
      <div className={styles.ClimbPicker}>
        <h2><Msg m={messages.climbAnimation} /></h2>
        <p><span className={styles.label}><Msg m={messages.selectedRide} />:</span> '{ride.get('name')}'</p>
        <div className={styles.mapContainer}>
          <Map
            height='300px'
            metricUnits={metricUnits}
            containerClassName={styles.MapContainer}
            routes={[ride]}
            onSegmentSelected={this.onSegmentSelected}
            onSegmentUnselected={this.onSegmentUnselected}
            sampleGraph />
        </div>
        <div>
          <Button type='default' onClick={this.confirmClimb} disabled={!readyToConfirm}><Msg m={commonVerbs.save} /></Button>
          {' '}
          {cancelable && <Button type='danger' onClick={onCancel}><Msg m={commonCTAs.cancel} /></Button>}
        </div>
        {showHint && <p><T id='ClimbPicker.hint' defaultMessage='Please click and drag on the elevation graph to select a segment of your ride' /></p>}
      </div>
    )
  }
}
